// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.unstoppabledomains",
    name: "Unstoppable Domains",
    homepage: "https://unstoppabledomains.com/",
    image_id: "4725dda0-4471-4d0f-7adf-6bbe8b929c00",
    app: {
        browser: "https://unstoppabledomains.com/",
        ios: "https://apps.apple.com/us/app/unstoppable-domains/id1544748602",
        android: "https://play.google.com/store/apps/details?id=com.unstoppabledomains.manager",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "unstoppabledomains://",
        universal: "https://unstoppabledomains.com/mobile",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map